<template>
	<div class="input-wrapper">
		<template v-for="inputId in amountOfInputs" :key="inputId">
			<text-input
				:force-focus="forceInputFocus[inputId]"
				:force-select="forceInputFocus[inputId]"
				:max-length="1"
				:model-value="inputValues[inputId]"
				:placeholder="placeholderObject[inputId]"
				:size="SizeOptions.L"
				class="input-overwrite"
				@keyup.backspace.exact.prevent="focusPrevious(inputId)"
				@keyup.arrow-left.exact.prevent="focusPrevious(inputId)"
				@keyup.arrow-right.exact.prevent="focusNext(inputId)"
				@update:modelValue="updateModelValue(inputId, $event)"/>
		</template>
	</div>
</template>
<script>
import {SizeOptions, TextInput} from "@datapas/vue-input";

export default {
	name: "AuthCodeInput",
	components: {
		TextInput,
	},
	emits: [
		'authCode',
		'keyup',
		'firstTimeCompletion'
	],
	props: {
		placeholder: {
			type: String,
			default: ''
		},
		amountOfInputs: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			SizeOptions,
			inputValues: {},
			forceInputFocus: {},
			isCompletedFirstTime: false
		};
	},
	computed: {
		authcode() {
			return Object.values(this.inputValues).join("");
		},
		placeholderValues() {
			const placeholderPerInput = {};

			const placeholderInputOffset = Math.floor((Math.max(this.amountOfInputs, this.placeholder.length) - this.placeholder.length) / 2);
			for (let index = 0; index < this.amountOfInputs; index++) {
				const placeholderIndex = (index - placeholderInputOffset);
				if (placeholderIndex >= 0 && placeholderIndex < this.placeholder.length) {
					placeholderPerInput[index + 1] = this.placeholder[placeholderIndex];
				}
			}

			return placeholderPerInput;
		},
		placeholderObject() {
			if (this.authcode) {
				return {};
			} else {
				return this.placeholderValues;
			}
		}
	},
	created() {
		for (let index = 1; index <= this.amountOfInputs; index++) {
			this.forceInputFocus[index] = 0;
			this.inputValues[index] = null;
		}
	},
	mounted() {
		this.forceInputFocus[1]++;
	},
	methods: {
		emitAuthCode(code) {
			this.$emit('authCode', code);
		},
		emitFirstTimeCompletion() {
			this.$emit('firstTimeCompletion');
		},
		updateModelValue(inputId, value) {
			if (!value) {
				this.inputValues[inputId] = null;
			} else if (value?.length > 1) {
				// Zorgt er voor dat je een gehele string kan plakken.
				let stringArrayValue = value.split("");
				let nextFocus = stringArrayValue.length > this.amountOfInputs - 1 ? this.amountOfInputs - 1 : stringArrayValue.length;
				for (let loopIndex = inputId; loopIndex <= Math.min(stringArrayValue.length, this.amountOfInputs); loopIndex++) {
					this.inputValues[loopIndex] = stringArrayValue[loopIndex - inputId];
				}
				this.focusNext(nextFocus);
			} else {
				this.inputValues[inputId] = value;
				this.focusNext(inputId);
			}

			if (this.authcode.length === this.amountOfInputs) {
				this.emitAuthCode(this.authcode);
				if (!this.isCompletedFirstTime) {
					this.emitFirstTimeCompletion();
					this.isCompletedFirstTime = true;
				}
			} else {
				this.emitAuthCode(null);
			}
		},
		focusPrevious(inputId) {
			if (inputId >= 1) {
				this.forceInputFocus[inputId - 1]++;
			}
		},
		focusNext(inputId) {
			if (inputId < this.amountOfInputs) {
				this.forceInputFocus[inputId + 1]++;
			}
		},
	}
};
</script>
<style lang="scss" scoped>
.input-overwrite {
	max-width: 35px;

	& :deep(.html-input input) {
		text-align: center;
	}
}
</style>